import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react'
import { EasyImg } from 'src/components'
import { appStore } from 'src/stores'
import 'src/styles/components/base/menuBar.less'

const MenuBar = () => {
  const [show, setShow] = useState(false)

  const navigate = useNavigate()

  const handleNav = (menu: any) => {
    navigate(`/main/${menu.ID}`)
  }

  return (
    <React.Fragment>
      <div
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        className={`menu-bar ${show ? 'show' : ''}`}
      >
        <div className='menu-bar__content'>
          {
            appStore.current.menus.map((menu: any, index: number) => {
              const { Node, Children = [] } = menu
              const appLogo = Node.ICON || require('src/assets/common/easyImg.png')
              return (
                <div
                  key={`${Node.ID}_${index}`}
                  onClick={() => !Children.length && handleNav(Node)}
                  className={`menu-bar__menu ${appStore.current.activeTopMenu?.IdLevels[0] === Node.ID ? 'active' : ''}`}
                >
                  <div className='menu-bar__menu-icon'>
                    <EasyImg src={appLogo} />
                  </div>
                  <div className='menu-bar__menu-font'>{Node.NAME}</div>
                  {
                    Children.length
                      ? (
                        <div className='menu-bar__menu-expand'>
                          {
                            Children.map((childMenu: any, childIndex: any) => {
                              const { Node: ChildNode, Children: ChildChildren = [] } = childMenu
                              const appLogo = ChildNode.ICON || require('src/assets/common/easyImg.png')
                              return (
                                <div
                                  key={`${ChildNode.ID}_${childIndex}`}
                                  onClick={() => !ChildChildren.length && handleNav(ChildNode)}
                                  className={`menu-bar__menu-submenu ${appStore.current.activeMenu.ID === ChildNode.ID ? 'active' : ''}`}
                                >
                                  <div className='menu-bar__menu-submenu--icon'>
                                    <EasyImg src={appLogo} />
                                  </div>
                                  <div className='menu-bar__menu-submenu--font'>{ChildNode.NAME}</div>
                                </div>
                              )
                            })
                          }
                        </div>
                      )
                      : null
                  }
                </div>
              )
            })
          }
        </div>
      </div>
      <div className={`menu-mask ${show ? 'show' : ''}`} />
    </React.Fragment>
  )
}

export default observer(MenuBar)